import dateToYMD from '../../shared/date-format'
import shortenExcerpt from '../../shared/shorten-excerpt'
import $ from 'jquery'

/**
 * LoadMoreButton function.
 * @return {Object} Factory function.
 */
export default function loadMoreButton () {
  let $el
  let page
  let excerpt
  let author
  let max_pages
  const morePostsContent = $('#more_posts')

  /**
   * Init function.
   *
   * @param {Object} el The main element.
   */
  function init (el) {
    if (!el) {
      return
    }

    $el = $(el)
    page = parseInt($el.attr('attr-page'), 10)
    excerpt = $el.attr('attr-excerpt')
    author = $el.attr('attr-author')
    max_pages = parseInt($el.attr('attr-maxpages'), 10)

    addEvents()
  }

  /**
   * Function to add font size button events.
   */
  function addEvents () {
    let base = `${window.location.origin}/wp-json/wp/v2/posts/?_embed=1`
    if (author > 0) {
      base += '&author=' + author
    }
    const postUri = `${base}&per_page=6&page=`

    $el.click(() => {
      page += 1
      max_pages -= 1

      $.get(postUri + page, function createHTML (data) {
        createHtml(data)
        $el.attr( 'attr-maxpages', max_pages )
      }).fail(function onFail () {
        morePostsContent.append('<p>An error has occurred. Please try again later</p>')
      }).done(function onDone () {
        if ( max_pages <= 1 ) {
          $el.fadeOut()
        }
      })
    })
  }

  /**
   * Create the Post HTML.
   *
   * @param {array} postData array The post data.
   */
  function createHtml (postData) {
    let output = ''

    for (let i = 0; i < postData.length; i++) {
      if (postData[i] !== 'undefined') {
        const postEmbeded = postData[i]._embedded

        const author = postEmbeded && postEmbeded['author'] && postEmbeded['author'][0] || ''
        const tags = postEmbeded && postEmbeded['wp:term'] && postEmbeded['wp:term'][1] || ''

        output += `<article id="post-${postData[i].id}" 
            class="post-${postData[i].id} post type-post format-standard hentry entry">`

        output += createHeaderHTML(postData, i)

        if (author) {
          output += createAuthorHTML(postData, i, author)
        }

        if (excerpt !== 0) {
          output += `<div class="m__blog-post-content">
            <p>${shortenExcerpt(postData[i].excerpt.rendered)}
            <a class="a__highlight-link" href="${postData[i].guid.rendered}">Read more</a>
            </p>`
        }

        output += createTagsHTML(tags)

        output += '</article>'
      }
    }
    $(morePostsContent).append(output)
    $el.attr('attr-page', page)
  }

  /**
   * Create Post header HTML
   *
   * @param {array} postData The Post Data.
   * @param {number} index The array index.
   * @returns {string} Returns the HTML.
   */
  function createHeaderHTML (postData, index) {
    return `<header class="entry-header"><h4 class="entry-title">
      <a href="${postData[index].guid.rendered}" rel="bookmark">
      ${postData[index].title.rendered}
      <h4></header>`
  }

  /**
   * Create Author Post HTML
   *
   * @param {array} postData The Post Data.
   * @param {number} index The array index.
   * @param {Object} author The author data.
   * @returns {string} Returns the HTML.
   */
  function createAuthorHTML (postData, index, author) {
    let output = '<div class="blog-post-meta">'

    if (excerpt !== 0) {
      output += `<div class="blog-post-meta__profile"><img src="${author.avatar_urls[96]}"></div>`
    }

    output += `<p>
        <a href="${author.link}">${author.name}</a> - ${dateToYMD(new Date(postData[index].date))}
        </p>
       </div>`

    return output
  }

  /**
   * Creates the Post tags HTML.
   *
   * @param {array} tags The Post tags data.
   * @returns {string} Returns the HTML.
   */
  function createTagsHTML (tags) {
    let output = ''

    if (tags && tags.length > 0) {
      output += '<div class="a__tags-list"><p>Tagged'

      for (let t = 0; t < tags.length; t++) {
        output += `<a href="${tags[t].link}" rel="tag">${tags[t].name}</a>`
      }

      output += '</p></div>'
    }

    return output
  }

  return Object.freeze({
    init: init
  })
}
